import { deferFactory } from 'utils/collections';
import * as api from '../../api';

const checkResponse = request =>
    request.then(response => {
        if (response.error) {
            throw new Error(response.error);
        }
        return typeof response.data !== 'undefined' ? response.data : response;
    });

const connectorsUrl = companyId => `/api/organization/${companyId}/connectors`;

export const installConnector = (companyId, identifier) =>
    checkResponse(api.post(connectorsUrl(companyId), { identifier }));

export const updateConnector = (companyId, uuid, rules, extra) =>
    checkResponse(api.patch(connectorsUrl(companyId), { uuid, rules, extra }));

export const resetConnector = (companyId, uuid) =>
    checkResponse(api.patch(connectorsUrl(companyId), { uuid, api_key: true }));

export const synchronizeConnector = (companyId, uuid) =>
    checkResponse(
        api.patch(connectorsUrl(companyId), { uuid, synchronize: true })
    );

export const removeConnector = (companyId, uuid) =>
    checkResponse(api.remove(connectorsUrl(companyId), { uuid }));

export const loadConnectors = companyId =>
    checkResponse(api.get(connectorsUrl(companyId)));

const backupUrl = (companyId, auid, days) =>
    `/api/organization/${companyId}/backups/${auid}?days_ago=${days}`;

export const loadNextBackups = (companyId, auid, days) =>
    checkResponse(api.get(backupUrl(companyId, auid, days)));

export const loadBackupsUsers = companyId =>
    checkResponse(api.get(`/api/organization/${companyId}/backups`));

export const loadGroups = companyId =>
    checkResponse(api.get(`/api/organization/${companyId}/groups`));

export const loadGroup = (companyId, groupId) =>
    checkResponse(
        api.get(`/api/organization/${companyId}/groups`, {
            group_uuid: groupId,
        })
    );

export const loadUsers = companyId =>
    checkResponse(api.get(`/api/organization/${companyId}/users`));

export const loadDevices = companyId =>
    checkResponse(api.get(`/api/organization/${companyId}/devices`));

export const removeDevices = (companyId, data) =>
    checkResponse(api.remove(`/api/organization/${companyId}/devices`, data));

export const loadTimezones = deferFactory(() =>
    checkResponse(api.get('/api/timezones'))
);
